<div class="agpr-addMentionsWidget-content">
    <div class="agpr-addMentionsWidget-contentTop">
        <agpr-monitoring-source-picker-with-facet-field
            #sourcePicker
            [id]="id + '_sourcePickerField'"
            [field]="sourcePickerField"
            [showHiddenOption]="true"
            [onlySocial]="onlySocial"
            [showSortOrder]="showSortOrder"
        ></agpr-monitoring-source-picker-with-facet-field>
        <div class="agpr-addMentionsWidget-paginationRow">
            <div class="agpr-addMentionsWidget-selectToggle">
                @if (showSelectToggle) {
                    <agpr-checkbox
                        [id]="id + '_selectToggle'"
                        [tooltip]="selectedMentions.length < searchMentions.length ? 'Monitoring.result.selectAll' : 'Monitoring.result.selectNone'"
                        tooltipPosition="top"
                        [disabled]="searchMentions.length < 1"
                        [binary]="true"
                        [partialSelected]="someSelected"
                        [ariaLabel]="selectedMentions.length < searchMentions.length ? 'Monitoring.result.selectAll' : 'Monitoring.result.selectNone'"
                        ariaDescribedBy="briefing_importDialog_selectedMentions"
                        [ngModel]="allSelected"
                        (ngModelChange)="toggleSelect()"
                    ></agpr-checkbox>
                }
                <span
                    [id]="id + '_selectedMentions'"
                    class="agpr-mentionsCount"
                    [ngClass]="{'agpr-mentionsCount--disabled': searchMentions.length < 1}"
                >
                    <span class="agpr-mentionsCount-selectedCount">
                        {{ selectedMentions.length }}
                    </span>
                    {{ 'Monitoring.result.of' | localize }}
                    <span class="agpr-mentionsCount-total">
                        {{ mentionCount }}
                    </span>
                    <span class="u-srOnly">{{ 'Paginator.selected' | localize }}</span>
                </span>
            </div>
            <div class="agpr-addMentionsWidget-paginator">
                <agpr-paginator
                    [id]="id + '_addMentionsWidget_paginator'"
                    [isDisabled]="searchMentions.length < 1"
                ></agpr-paginator>
            </div>
        </div>
    </div>
    <div
        class="ui-g agpr-addMentionsWidget-contentWrapper"
        [agprLoading]="isLoading"
    >
        <agpr-scroll-panel>
            <div class="agpr-addMentionsWidget-contentResults">
                @if (!isLoading) {
                    @if (searchMentions?.length > 0) {
                        <agpr-mention-list
                            [id]="id + '_mentionList'"
                            [mentions]="searchMentions"
                            [enableFocus]="false"
                            [showAllImages]="false"
                            [badges]="mentionBadges"
                            [checkboxDisabled]="shouldCheckboxBeDisabled"
                            [checkboxCanBeDisabledWhenChecked]="false"
                            [(ngModel)]="selectedMentions"
                            (ngModelChange)="selectedMentionsChanged()"
                            [highlightSavedMentions]="false"
                        ></agpr-mention-list>
                    } @else {
                        <agpr-message [severity]="messageSeverityEnum.noContent">
                            {{ 'Briefings.addCoverage.manual.noItems' | localize }}
                        </agpr-message>
                    }
                }
            </div>
        </agpr-scroll-panel>
    </div>
</div>
